import { ButtonSize } from 'components/ButtonDeprecated';
import React from 'react';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
// @ts-ignore
import mapGraphQLMemberToUserActionsMenuButtonUser from 'user/lib/mapGraphQLMemberToUserActionsMenuButtonUser';
import { UserProfile } from 'users/components/UsersProfile';

export type Props = {
  organization: {
    id: number;
    uuid: string;
    name: string;
  };
  member: UserProfile;
  isPrivateNoteVisible: boolean;
  onUserRemoved: () => void;
  onUserUpdate: (eventName?: string) => Promise<void>;
  onGetTranscript: (value: boolean) => void;
  onRevealPrivateNote: () => void;
};

export default function OrganizationMemberActionsMenuButton(props: Props) {
  const {
    isPrivateNoteVisible,
    organization,
    member,
    onUserRemoved,
    onUserUpdate,
    onGetTranscript,
    onRevealPrivateNote,
  } = props;
  const { userInteractionPermissions, preferences } = member;
  const {
    canBlock,
    canChangeRole,
    canCopyToAnotherGroup,
    canGetMessageHistory,
    canRequestMessageHistory,
    canRemoveFromGroup,
    canReportToRemind,
    canBanNameChanges,
    canChangeName,
    canUpdatePreferredLanguage,
  } = userInteractionPermissions;

  return (
    <UserActionsMenuButton
      buttonSize={ButtonSize.xsmall}
      copyToClassText="Add to a class"
      glyphSize="inherit"
      organization={organization}
      isAdminView
      isPrivateNoteVisible={isPrivateNoteVisible}
      showAddPrivateNote
      showChangeRole={canChangeRole}
      showCopyToClass={canCopyToAnotherGroup}
      showGetTranscript={canGetMessageHistory || canRequestMessageHistory}
      showBlockMember={canBlock}
      showRemoveFromSchool={canRemoveFromGroup}
      showReportAsAdmin={canReportToRemind}
      user={mapGraphQLMemberToUserActionsMenuButtonUser(member)}
      onUserRemoved={onUserRemoved}
      onUserUpdate={onUserUpdate}
      onGetTranscript={onGetTranscript}
      onRevealPrivateNote={onRevealPrivateNote}
      tooltip="More actions"
      tooltipPlacement="top"
      canBanNameChanges={canBanNameChanges}
      canChangeName={canChangeName}
      canUpdatePreferredLanguage={canUpdatePreferredLanguage}
      preferredLanguage={preferences?.preferred_language}
    />
  );
}
